import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import Constants from 'src/core/utils/Constants';

interface ViewportState {
	/** Widest the app renders in a browser. One number, one place. */
	maxContentWidth: number;
}

const initialState: ViewportState = { maxContentWidth: Constants.maxContentWidth };

/**
 * Holds the column width for the web build. It lives in a store rather than in a prop because the
 * column wraps the navigator -- so it sits above every screen and cannot be reached from inside
 * one.
 *
 * Widening it per screen (a timetable, a floorplan) is a follow-up ticket, so there is nothing
 * here to set it yet: a setter that nothing calls, with a docstring describing behaviour that does
 * not exist, is worse than no setter.
 *
 * On native nothing reads this: the app fills the screen there and the wrapper is a passthrough.
 */
export const useViewportStore = create(combine(initialState, () => ({})));
